<template>
  <Section
    decoration="/images/spiral.svg"
    :index="7"
    :title="t('sections.contact')"
    id="contact"
  >
    <p class="contact__prompt">
      {{ t('contact.prompt') }}
    </p>

    <a 
      :href="`mailto:${email}`"
      class="contact__email"
    >
      {{ email }}
    </a>

    <p
      class="contact__description"
    >
      {{ t('contact.description') }}
    </p>

    <ul class="contact__list">
      <li
        v-for="contact in contacts"
        :key="contact.name"
      >
        <a
          :href="contact.link"
          target="_blank"
          rel="noopener noreferrer"
          class="contact__link"
        >
          {{ contact.name }}
        </a>
      </li>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import Section from '@/ui/Section.vue';

const { t } = useI18n();

const email = 'liviawebdev@proton.me';

const contacts = [
  {
    name: 'GitHub',
    link: 'https://github.com/liviaalmeida',
  },
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/in/livia001/',
  },
];
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';

.contact__prompt {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-size: 40px;
  font-weight: 400;
}

.contact__email {
  border-bottom: 1px solid var(--color-highlight);
  color: var(--color-text-strong);
  display: inline-block;
  font-family: var(--font-family-display);
  font-size: 24px;
  font-weight: 400;
  margin: 8px 0 24px;
}

.contact__list {
  display: flex;
  gap: 32px;
  margin-top: 24px;
}

.contact__link {
  @include mixins.monotext(true);
}
</style>
